
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ceremony",
      function () {
        return require("private-next-pages/ceremony.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ceremony"])
      });
    }
  